import { render, staticRenderFns } from "./TagFilterProductList.vue?vue&type=template&id=31cddf59&scoped=true"
import script from "./TagFilterProductList.vue?vue&type=script&lang=js"
export * from "./TagFilterProductList.vue?vue&type=script&lang=js"
import style0 from "./TagFilterProductList.vue?vue&type=style&index=0&id=31cddf59&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cddf59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31cddf59')) {
      api.createRecord('31cddf59', component.options)
    } else {
      api.reload('31cddf59', component.options)
    }
    module.hot.accept("./TagFilterProductList.vue?vue&type=template&id=31cddf59&scoped=true", function () {
      api.rerender('31cddf59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/TagFilterProductList.vue"
export default component.exports